import React, { useMemo, useState } from 'react';
import { Image, StyleSheet, View } from 'react-native';
import { WaitForLoadImage } from '../../shell/ImageHandler/WaitForLoadImage';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { setAdvance } from '../../store/slices/AdvanceSlice';
import { selectClickableMap, setClickableMap } from '../../store/slices/gameObjectSlice';

interface TClickableMapProps {

}

export const ClickableMap: React.FC<TClickableMapProps> = React.memo(({ }) => {
    const ClickableMapSlice = useAppSelector(selectClickableMap);
    // const ClickableMapSlice = useMemo(() => store.getState().gameObject.present.clickableMap, [store.getState().gameObject.present.clickableMap.key]);
    const [hoveredImage, setHoveredImage] = useState<string | null>();
    const dispatch = useAppDispatch();

    const styles = StyleSheet.create({

        container: {
            position: "absolute",
            width: "100%",
            height: "100%"

        },

    });
    const getPartials = useMemo(() => {
        return ClickableMapSlice?.clickableImages?.map(item => (
            <Image
                key={item.key}
                source={item.image.url}
                style={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    opacity: 1,
                    flex: 1,
                }}
                resizeMode={'cover'}
            />
        ));
    }, [ClickableMapSlice]);


    // const getPartials = () => {
    //     const partials = ClickableMapSlice.clickableImages.map(item => {
    //         return <Image key={item.key} source={item.image.url} style={{
    //             position: "absolute",
    //             width: "100%",
    //             height: "100%",
    //             opacity: 1,
    //             flex: 1,


    //         }} resizeMode={'cover'} ></Image >;
    //     });

    //     return partials;
    // };
    const handleOnClick = async (value?: string | null) => {
        if (!value) { return; }
        const clickableItemKey = ClickableMapSlice.clickableImages.find(item => item.image.url === value)?.key;
        if (!clickableItemKey) {
            console.log("couldn't find image", value);
            return;
        }
        dispatch(setAdvance({ canAdvance: true, promise: clickableItemKey }));
        dispatch(setClickableMap({ ...ClickableMapSlice, displayClickableMap: false, key: ClickableMapSlice.key, value: clickableItemKey }));

    };
    const onHovered = (img: string | null) => {
        console.log("TClickableMap", img);
        setHoveredImage(img ? img : null);
    };

    return (
        <>
            {ClickableMapSlice?.displayClickableMap ?
                <View style={styles.container}>

                    {/* <WaitForLoadImage source={ClickableMapSlice.mainImage.url} ></WaitForLoadImage> */}
                    {/* {ClickableMapSlice.clickableImages.map((item) => { */}
                    {/* return ( */}
                    {/* <React.Fragment key={item.key}> */}
                    <WaitForLoadImage source={ClickableMapSlice.mainImage.url} partials={getPartials} style={{ width: "100%", height: "100%" }}
                        clickableItem={(item) => {
                            handleOnClick(item);
                        }}
                        hoveredTriggered={onHovered}
                    ></WaitForLoadImage>
                    {/* <HighlightedImage url={ClickableMapSlice.clickableImages[0].highlightImage.url} visible={!!hoveredImage}></HighlightedImage> */}
                    {/* <Image source={ClickableMapSlice.clickableImages[0].highlightImage.url} style={{ width: "100%", height: "100%", position: "absolute", pointerEvents: "none" } as any}></Image> */}

                    {/* ); */}
                    {/* } */}
                    {/* )} */}
                </View>
                : <></>}
        </>
    );
});